export default "__VITE_ASSET__5523188d__"